import useVentaEventoDemo from "./useVentaEventoDemo";
import useVentaEventoReal from "./useVentaEventoReal";

// Create React App inyecta las variables REACT_APP_* durante el build.
// eslint-disable-next-line no-undef
export const ES_MODO_DEMO = process.env.REACT_APP_VENTA_EVENTO_DEMO === "true";

// Punto único de sustitución: con la variable de demo activa la pantalla sigue
// corriendo sobre los mocks; en cualquier otro caso usa el adaptador real.
// Los hooks se invocan ambos en el mismo orden en todos los renders porque la
// variable de entorno es fija durante el build.
export default function useVentaEvento() {
  const demo = useVentaEventoDemo();
  // En modo demo no se consulta el backend: la pantalla corre sin sesión.
  const real = useVentaEventoReal({ skip: ES_MODO_DEMO });
  return ES_MODO_DEMO ? { ...demo, esDemo: true, habilitado: true } : { ...real, esDemo: false };
}
